<template>
    <div>
        <div class="menuContain">
            <div class="menuCont">
                <img src="@/assets/tiantaiLogo.png" class="MenuLeft">
                <ul>
                    <li @mousemove="onMousemove(0)" @mouseleave="onMouseleave">
                        <span @click="to('/')">首页</span>
                    </li>
                    <li @mousemove="onMousemove(1)" @mouseleave="onMouseleave">
                        <span @click="to('/about')">关于我们</span>
                    </li>
                    <div class="line" :style="{left:lineLeft}"></div>
                </ul>
            </div>
        </div>
        <div class="bannerContain">
            <swiper :options="swiperOption">
                <swiper-slide>
                    <img src="@/assets/images/banner_guoqingsi.jpg" class="bannerImage" />
                </swiper-slide>
                <swiper-slide>
                    <img src="@/assets/images/banner_chichenshan.jpg" class="bannerImage" />
                </swiper-slide>

                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        defaultMenu:{
            type:Number,
            default:0
        }
    },
    data() {
        return {
            current:0,
            swiperOption: {
                autoplay: { delay: 3000 },
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                }
            }
        }
    },
    computed:{
        lineLeft:function(){
            return `${100 * this.current + 25}px`
        }
    },
    created(){
        this.current = this.defaultMenu
    },
    methods:{
        to(url){
            if(this.$route.path != url){
                this.$router.push(url)
            }
        },
        onMousemove(index){
            this.current = index 
        },
        onMouseleave(){
            this.current = this.defaultMenu
        }
    }
}
</script>
<style lang="less" scoped>
.menuContain {
    position: fixed;
    width: 100%;
    height: 80px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    min-width: 1200px;
    z-index: 12;

    .menuCont {
        width: 1200px;
        height: 80px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .MenuLeft {
            display: block;
            height: 60px;
        }

        ul {
            display: flex;
            flex-direction: row;
            position: relative;
            li {
                width: 100px;
                height: 80px;
                cursor: pointer;

                span {
                    color: #fff;
                    font-size: 16px;
                    line-height: 80px;
                    font-weight: 500;
                }
            }
            .line{
                width: 50px;
                height: 2px;
                background-color: #FFF;
                position: absolute;
                bottom: 20px;
                transition: left 200ms linear;
            }
        }
    }
}

.bannerContain {
    position: relative;
    .bannerImage {
        width: 100%;
        display: block;
    }

    /deep/ .swiper-pagination {
        bottom: 30px;
    }

    /deep/ .swiper-pagination-bullet {
        width: 30px;
        height: 3px;
        background-color: #FFF;
        border-radius: 1.5px;
        margin: 0 4px;
    }

    /deep/ .swiper-pagination-bullet-active {
        background-color: #0b82f1;
    }
}
</style>